













































































import Vue from 'vue'
import { Component } from '@niknevis/vue-modules'
import { Prop } from 'vue-property-decorator'
import BaseButton from '@/modules/shared/components/shared/kit/BaseButton.vue'
import { MessageBoardCollection } from '@/modules/common/message-board/models/message-board-collection.model'
import { MessageBoardAppendMessages } from '@/modules/common/message-board/models/message-board-custom-messages'
import InitialPropsStore from '@/modules/common/layout/store/initial-props.store'
import QCarousel from 'quasar/src/components/carousel/QCarousel.js';

@Component({
  components: {
    BaseButton
  }
})
export default class MessageBoardCarousel extends Vue {
  constructor(
    protected readonly initialProps: InitialPropsStore
  ) {
    super()
  }

  @Prop({ default: () => ({ data: [] }) }) backendMessages!: MessageBoardCollection[]
  @Prop({ default: () => ({ data: [] }) }) appendMessages!: MessageBoardCollection[]
  messages: MessageBoardCollection[] = []
  autoplay: boolean | number = 5000
  slide = 'slide0'

  $refs: {
    carousel: QCarousel
  }

  mounted() {
    //messages
    setTimeout(() => {
      this.messages = this.allMessages
    }, 0)
  }


  //Computed:
  get allMessages(): MessageBoardCollection[] {
    let messages = (this.appendMessages)
      ? this.appendMessages.concat(MessageBoardAppendMessages(this.initialProps))
      : MessageBoardAppendMessages(this.initialProps)
    return this.backendMessages.concat(messages)
  }

  //Methods
  messagesProps(index) {
    return this.messages[index].binds
  }

  onEvent(event) {
    this.autoplay = !event
  }

  carouselBg(type) {
    if (type === 'warning') {
      return 'bg-tes-gradient-orange'
    } else if (type === 'success') {
      return 'bg-tes-gradient-green'
    } else if (type === 'info') {
      return 'bg-tes-gradient-blue'
    } else if (type === 'danger') {
      return 'bg-tes-gradient-red'
    }
  }
}
